import { useState, useEffect } from 'react';
import axios from 'axios';
import PropTypes from 'prop-types';

// API URL from the environment variables
const apiUrl = "https://application-backend.age-namur.be/api";

// Axios instance to make API requests
const API = axios.create({
    baseURL: apiUrl,
});

export { API };

/**
 * Custom hook to fecth data from an API using axios
 * @param {string} path - The path to the API endpoint
 * @returns {Object} - An object containing the data, loading and error states
 *  - data: The fetched data from the API. Default value is an empty array ([])
 *  - loading: A boolean to indicate if the data is still being fetched. Default value is true
 *  - error: The error object if the fetch request fails. Default value is null
 * @example
 * const { data, loading, error } = useApi('data/');
 */
export const useApi = (path) => {
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        const fetchData = async () => {
            try {
                const response = await API.get(path);
                setData(response.data);
            } catch (error) {
                setError(error);
            } finally {
                setLoading(false);
            }
        };
        fetchData();
    }, [path]);

    return { data, loading, error };
};

// Prop types for the useApi hook
useApi.propTypes = {
    path: PropTypes.string.isRequired,
};
